module.exports = __webpack_public_path__ + "static/countdownBack-db8f09b636fd6bef620eef02444b81a1.png";